import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    bsReports: {
        data: [],
    },
};

const bsReportsSlice = createSlice({
    name: "bsReports",
    initialState,
    reducers: {
        bsReportsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        bsReportsSuccess: (state, action) => {
            state.loading = false;
            state.bsReports.data = action.payload.data;
        },
        bsReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
    }
});

export const {
    bsReportsStart,
    bsReportsSuccess,
    bsReportsFailure
} = bsReportsSlice.actions;

export default bsReportsSlice.reducer;